import * as actionTypes from '../actions/types'
import { updateObject } from './Utility';

const initialState = {
    token: null,
    userId: null,
    error: null
}

export const authStart = (state, action) => {
    console.log('auth start');
    return updateObject(state, {error: null});
}

export const authSuccess = (state, action) => {
    return updateObject(state, {
        token: action.idToken,
        userId: action.userId,
        error: null});
}

const authLogout = (state, action) => {
    return updateObject(state, {token: null, userId: null});
}

export const authFailure = (state, action) => {
    return updateObject(state, {
        error: action.error});
}

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.AUTH_START: return authStart(state, action);
        case actionTypes.AUTH_SUCCESS: return authSuccess(state, action);
        case actionTypes.AUTH_FAILURE: return authFailure(state, action);
        case actionTypes.AUTH_LOGOUT: return authLogout(state, action);
        default: return state;
    }
}

export default reducer;